import { ComboboxOption } from '@headlessui/react'
import { BriefcaseIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline'
import React from 'react'

const quickActions = [
  { name: 'Rechercher un cabinet...', icon: BuildingOfficeIcon, url: '/cabinets' },
  { name: 'Rechercher une offre...', icon: BriefcaseIcon, url: '/offres' },
]

export const QuickActions = ({ query = '' }: { query: string }) => {
  if (query !== '') {
    return null
  }

  return (
    <li className="p-2">
      <h2 className="sr-only">Quick actions</h2>
      <ul className="text-sm text-gray-700">
        {quickActions.map((action) => (
          <ComboboxOption
            as="li"
            key={action.name}
            value={action.url}
            className="flex items-center px-3 py-2 rounded-md cursor-default select-none group data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
          >
            <action.icon
              className="size-6 flex-none text-gray-400 group-data-focus:text-white forced-colors:group-data-focus:text-[Highlight]"
              aria-hidden="true"
            />
            <span className="flex-auto ml-3 truncate">{action.name}</span>
          </ComboboxOption>
        ))}
      </ul>
    </li>
  )
}
